import React from 'react'
import { VersionDeletedFragment } from 'gqlTypes'
import VersionItem from 'components/VersionItem/VersionItem'

export interface ShareVersionDeletedItemProps {
  version: VersionDeletedFragment
}

export const ShareVersionDeletedItem = ({
  version,
}: ShareVersionDeletedItemProps) => {
  const { userIsCreator, creator } = version
  const createdAt = new Date(version.createdAt)

  return (
    <VersionItem
      type="deleted"
      creator={creator.name!}
      date={createdAt}
      userIsCreator={userIsCreator}
      kind={'DRAFT'}
    />
  )
}
